export default "__VITE_ASSET__DjFn0NW2__"